import Vue from 'vue'
import VueRouter from 'vue-router'
/*
import Home from '@/components/Home.vue'
import Login from '@/components/Login.vue'
import Wellcome from '@/components/Wellcome.vue'
import Test1 from '@/views/Test1.vue'
import Test2 from '@/views/Test2.vue'
import Test3 from '@/views/Test3.vue'
import Test4 from '@/views/Test4.vue'
import Test5 from '@/views/Test5.vue'
import Test6 from '@/views/Test6.vue'
import Test7 from '@/views/Test7.vue'*/


// 引入加载条
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
// 配置
NProgress.inc()
NProgress.configure({
  easing: 'ease', // 动画方式
  speed: 800, // 递增进度条的速度
  showSpinner: false, // 是否显示加载ico
  trickleSpeed: 200, // 自动递增间隔
  minimum: 0.1 // 初始化时的最小百分比
})

Vue.use(VueRouter)

// 所有人都可以访问
const routes = [
  /*
    { path: '/', redirect: '/home' },
    { path: '/login',component:Login, meta:{title:'登录'}},
    // 访问home时，重定向到wellcome页
    { path: '/home', name: 'home', component: Home, redirect: '/wellcome', meta: {title: '控制台'},
        children: [
        { path: '/wellcome', name: 'wellcome', component: Wellcome, meta: {title: '控制台'}},
        { path: '/test1', name: 'test1', component: Test1, meta: {title: '测试页面1'}},
        { path: '/test2', name: 'test2', component: Test2, meta: {title: '测试页面2'}},
        { path: '/test3', name: 'test3', component: Test3, meta: {title: '测试页面3'}},
        { path: '/test4', name: 'test4', component: Test4, meta: {title: '测试页面4'}},
        { path: '/test5', name: 'test5', component: Test5, meta: {title: '测试页面5'}},
        { path: '/test6', name: 'test6', component: Test6, meta: {title: '测试页面6'}},
        { path: '/test7', name: 'test7', component: Test7, meta: {title: '测试页面7'}},
        ]
    },*/
]

const router = new VueRouter({
  routes
})

/**
 * 挂载路由守卫
 * to 代表将要访问的路径
 * from 代表从哪个路径跳转而来
 * next 是一个函数，next() 放行。   next('/login') 强制跳转
 */
router.beforeEach((to, from, next) => {
  //console.log('===========router before=========')
  // 加载条
  NProgress.start()
 // console.log('======debug====')
 // console.log(to)
  let token = window.localStorage.token;
 // console.log(token)
  if (to.path !== '/login') {
    if (token === 'null' || token === '' || token === undefined) {
      next({
        path: '/login'
      })
      // Toast({ message: '检测到您还未登录,请登录后操作！', duration: 1500 })
    } else {
      next()
    }
  } else {
    next()
  }

})


// 挂载路由守卫 - 访问结束
router.afterEach(() => {
  // 关闭加载条
  NProgress.done()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js